import { Qna } from 'actions/actionTypes';

// 이벤트
export const changeSearchFilter = (type, name, value) => ({ type: Qna.CHANGE_SEARCH_FILTER, payload: { type, name, value } });
export const changeQuestion = (name, value) => ({ type: Qna.CHANGE_QUESTION, payload: { name, value } });
export const addQuestion = () => ({ type: Qna.ADD_QUESTION });

// 검색 필터 초기화
export const searchQnaFilterReset = () => ({ type: Qna.SEARCH_QNA_FILTER_RESET });

// 문의 목록 조회
export const loadQnaListRequest = () => ({ type: Qna.LOAD_QNA_LIST_REQUEST });
export const loadQnaListSuccess = (gameHistoryList) => ({ type: Qna.LOAD_QNA_LIST_SUCCESS, payload: gameHistoryList });
export const loadQnaListFailure = (errorMessage) => ({ type: Qna.LOAD_QNA_LIST_FAILURE, payload: errorMessage });

// 문의 등록
export const addQnaQuestionRequest = () => ({ type: Qna.ADD_QNA_QUESTION_REQUEST });
export const addQnaQuestionSuccess = () => ({ type: Qna.ADD_QNA_QUESTION_SUCCESS });
export const addQnaQuestionFailure = (errorMessage) => ({ type: Qna.ADD_QNA_QUESTION_FAILURE, payload: errorMessage });

// 문의 상세 조회
export const loadQnaInfoRequest = (idx) => ({ type: Qna.LOAD_QNA_INFO_REQUEST, payload: { idx } });
export const loadQnaInfoSuccess = (responseData) => ({ type: Qna.LOAD_QNA_INFO_SUCCESS, payload: responseData });
export const loadQnaInfoFailure = (errorMessage) => ({ type: Qna.LOAD_QNA_INFO_FAILURE, payload: errorMessage });